
import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Button,
    Avatar,
    TextField,

} from "@mui/material";
import { VideoCall, Chat, Call, Search } from "@mui/icons-material";
import image from "../../Assets/profile_img.jpg"

// import CustomStar from "../../../Components/CustomStar/CustomStar";
import { FaUser } from "react-icons/fa";
import "./CustomUserCard.css"
import { BsFilterLeft } from "react-icons/bs";
import { FiFilter } from "react-icons/fi";

// import offerImages from "../../../Assets/offerImages.png"
import { IoLanguage } from "react-icons/io5";
// import premiumImage from "../../../Assets/premium.png"
import { FaCheckCircle } from "react-icons/fa";
import actions from "../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";


const userLists = [
    { name: "Bharathiji", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },
    { name: "valla", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },
    { name: "Bharathiji", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },
    { name: "Bharathiji", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },
    { name: "Bharathiji", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },
    { name: "Bharathiji", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },
    { name: "Bharathiji", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },
    { name: "Bharathiji", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },
    { name: "Bharathiji", image: image, course: "Apparel Marketing Merchandising and Management", location: "Bangaluru" },

];




const UserCard = ({ userData, handleConnectButton }) => (

    <Card
        sx={{
            // borderRadius: 3,
            boxShadow: 2
        }}>
        <CardContent
            sx={{
                boxShadow: 'none',
                '& .MuiCard-root': {
                    boxShadow: 'none',
                },
            }}
        >

            <Grid
                container
                spacing={4}
                sx={{ p: 2 }}
                alignItems="center" justifyContent="space-between" flexDirection={{ xs: "column", md: "row", sm: "column" }}>
                <Grid
                    item size={{ md: 4 }} sx={{ display: "flex", paddingTop: "0px", justifyContent: "center", flexDirection: "column" }}>
                    <Avatar
                        sx={{ width: 70, height: 70 }}
                        src={userData?.profileImage}
                    // src={image}

                    >
                        {/* <Box
                            component="img"
                            src={userData?.image} sx={{ width: 70, height: 70, objectFit: "contain" }}
                        >

                        </Box> */}
                    </Avatar>

                </Grid>
                <Grid item size={{ md: 8 }} sx textAlign={{ xs: "center", md: "start", sm: "center", paddingTop: "0px", }}>
                    <Typography variant="h6" fontWeight={600}>{userData?.name}</Typography>
                    <Typography variant="body1">{userData?.course}</Typography>
                    <Typography variant="body1">@{userData?.campus}</Typography>
                    <Typography variant="body1">{userData?.batch}</Typography>



                </Grid>
                <Button
                    onClick={() => {
                        handleConnectButton(userData?.connect_userId)
                    }}
                    variant="contained"
                    color="primary"
                    fullWidth
                    // startIcon={<VideoCall style={{ fontSize: "12px" }} />}
                    sx={{
                        fontSize: "14px",
                        textTransform: "none",
                        mr: "2px",
                        color: "white",
                        background: "var(--main-color)",
                        // borderRadius: "20px",
                        padding: "5px 9px",
                        boxShadow: "none"
                    }}
                >
                    Connect
                </Button>
            </Grid>
        </CardContent>
    </Card>
);

const CustomUserCard = () => {
    const [searchQuery, setSearchQuery] = useState("");


    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    // const filteredUsers = userLists.filter((user) =>
    //     user.name.toLowerCase().includes(searchQuery) ||
    //     user.course.toLowerCase().includes(searchQuery) ||
    //     user.location.toLowerCase().includes(searchQuery)
    // );
    const dispatch = useDispatch()


    const sessionUserId = sessionStorage.getItem("userId")

    const { sendConnectionRequest } = useSelector(
        (state) => state?.sendConnectionRequest
    );
    const [connectionUserData, setConnectionUserData] = useState([])

    console.log(connectionUserData, "connectionUserData")


    const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';

    useEffect(() => {
        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUsersWithoutConnections/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETALLUSERS(data1));
            console.log(response, "responsedataaaaaaa")
            if (response?.payload?.message === "Users without connections fetched successfully.") {

                console.log(response, "responsedataaaaaaa1111")

                const responseData = response?.payload?.data?.map((data) => ({
                    connect_userId: data?.user_id,
                    name: `${capitalize(data?.first_name)} ${capitalize(data?.last_name)}`,
                    course: capitalize(data?.course),
                    campus: capitalize(data?.campus),
                    profileImage: data?.profileImage,
                    batch: data?.batch



                }))
                setConnectionUserData(responseData)
            }

        }
        fetchData()
    }, [sendConnectionRequest])

    // const sessionUserId=sessionStorage.getItem("userId")

    const handleConnectButton = async (connect_userId) => {
        console.log(connect_userId, "userrrrrrrrr")
        const data1 = {
            data: {
                sender_id: Number(sessionUserId),
                receiver_id: Number(connect_userId)
            },
            method: "post",
            apiName: `sendConnectionRequest`,
        };
        const response = await dispatch(actions.SENDCONNECTIONREQUEST(data1));
        console.log(response, "responsedataaaaaaa")
        if (response?.payload?.message === "Connection request sent.") {
            toast?.success('Connection request sent successfully!')
        } else {
            toast.error(response?.payload?.message)
        }


    }

    // const userLists = ConnectionsGetAll?.data?.map((data) => ({
    //     id: data?.id,
    //     name: `${data?.first_name} ${data?.last_name}`,
    //     image: null,
    //     course: data?.course,
    //     location: data?.present_city
    // }))

    const filteredUsers = connectionUserData.filter((user) =>
        user.name.toLowerCase().includes(searchQuery) ||
        user.course.toLowerCase().includes(searchQuery) ||
        user.campus.toLowerCase().includes(searchQuery) ||
        user.batch.toLowerCase().includes(searchQuery)



    );





    return (
        <Box
            sx={{
                p: {md:3},
                mt: {xs:2,md:0},
                // background: "#f9f5ed"
                background: "white"

            }}
        >
            <Box
                // display="flex" justifyContent="space-between" alignItems="center" 
                mb={3}>
                <Box display="flex" flexDirection={{ xs: "column", md: "row" }} alignItems="center" justifyContent="space-between" gap={2}>
                    {/* Filters */}


                    {/* Status Filters */}
                    <Box display="flex" flexDirection={{ xs: "column", md: "row" }} justifyContent="space-between" width="100%" alignItems="center">

                        <TextField
                            size="small"
                            placeholder="Search Experts"
                            variant="outlined"
                            InputProps={{ endAdornment: <Search /> }}
                            // sx={{borderRadius:'20px'}}
                            sx={{
                                minWidth: 200,
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "20px",
                                    "& fieldset": {
                                        borderRadius: "20px", // Applies to the actual border
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#F9BF10", // Change border color on hover
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#F9BF10", // Change border color on focus
                                    },
                                },
                            }}
                            value={searchQuery}
                            onChange={(event) => handleSearchChange(event)}
                        />
                    </Box>

                </Box>

            </Box>

            {/* Expert Cards */}
            <Grid container spacing={3}>


                {filteredUsers.length > 0 ? (
                    filteredUsers.map((userData, index) => (
                        <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <UserCard userData={userData} handleConnectButton={handleConnectButton} />
                        </Grid>
                    ))
                ) : (
                    <Typography variant="h6" sx={{ textAlign: "center", width: "100%", mt: 2 }}>
                        No experts found.
                    </Typography>
                )}

            </Grid>
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />

        </Box>
    );
};

export default CustomUserCard;